import { render } from "./RecentSales.vue?vue&type=template&id=56706505&scoped=true&ts=true"
import script from "./RecentSales.vue?vue&type=script&lang=ts"
export * from "./RecentSales.vue?vue&type=script&lang=ts"

import "./RecentSales.vue?vue&type=style&index=0&id=56706505&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56706505"]])

export default __exports__